import React, { useEffect, useState } from "react";
import { useAuth } from "../../hooks/auth";
import { VehicleType } from "../../interfaces/VehicleType";
import VehicleTypeApi from "../../services/VehicleTypeApi";
import Select from "./Select";

type Props = any;

const SelectVehicleType: React.FC<Props> = ({ name, control, multiple, style, label, disabled}) => {
  const { user } = useAuth()
  const [vehicleTypeList, setVehicleTypeList] = useState<any>([])
  const [first, setFirst] = useState<any>()

  useEffect(() => {
    VehicleTypeApi.searchAll()
        .then(response => {
            if (response){

              var items = response.map(
                (item: VehicleType) => ({
                  code: item.code, 
                  label: item.description
                })
              )

              setVehicleTypeList(items)
                setFirst(items[0])
            }
              
        });
  }, []);



  return (
    <Select 
      disabled={disabled}
      value={first}
      label={label} 
      name={name}
      control={control} 
      options={vehicleTypeList}
      multiline={multiple}
      style={style ? style : {width: '100%'}}/>
  )
}

export default SelectVehicleType;
